<body class="ltr main-body leftmenu">

    <form autocomplete="off" novalidate>
        <div class="main-content side-content pt-0 ml-0">
            <div class="main-container container-fluid">
                <div class="inner-body">
                    <div class="row row-sm add-form">
                        <form autocomplete="off" class="p-0" novalidate [formGroup]="SearchExamForm">
                            <div class="col-lg-12 col-md-12">
                                <div class="card custom-card">
                                    <div class="card-body">
                                        <div class=" d-flex align-items-center pl-3">
                                            <img alt="Logo" src="../../assets/img/CollegeMaster.png"
                                                class="mh-45px pb-2">
                                            <div class="ml-2">
                                                <h3 class="main-content-label mb-1"><b>
                                                    Search Exam Form
                                                    </b></h3>
                                                <p class="text-muted card-sub-title mb-0">
                                                    Search Exam Form </p>
                                            </div>
                                        </div>

                                        <hr class="mt-1 mb-2">
                                        <div class="row clearfix mt-3">
                                            <div class="col-sm-3">
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label> Exam</mat-label>
                                                        <mat-select required #select22 placeholder="Exam"
                                                            class="colorblack" formControlName="ShId">
                                                            <mat-select-filter *ngIf="select22.focused"
                                                                [placeholder]="'Exam'" [displayMember]="'EmName'"
                                                                [array]="examscheduleList"
                                                                (filteredReturn)="filteredListExamSch =$event">
                                                            </mat-select-filter>
                                                            <mat-option *ngFor="let item of filteredListExamSch"
                                                            [value]="item.ShId">
                                                            {{ item | displayValue:'EmCode':'EmName' }}
                                                            </mat-option>
                                                        </mat-select>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div class="col-sm-3">
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <input  matInput>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div class="col-sm-3">
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label>RgNo Like </mat-label>
                                                        <input formControlName="RgNo" matInput placeholder="RgNo Like">
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div class="col-sm-3">
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label> Category</mat-label>
                                                        <mat-select #select24 placeholder="" class="colorblack"
                                                            formControlName="EfCate">
                                                            <mat-select-filter *ngIf="select24.focused"
                                                                [placeholder]="'Filter'" [displayMember]="'CdDesc'"
                                                                [array]="ConstiCateList"
                                                                (filteredReturn)="filteredConstiCateList =$event">
                                                            </mat-select-filter>
                                                            <mat-option *ngFor="let item of filteredConstiCateList"
                                                                [value]="item.CdCode">
                                                                {{item.CdDesc}}
                                                            </mat-option>
                                                        </mat-select>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div class="col-sm-3">
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label> College</mat-label>
                                                        <mat-select required #select222 placeholder="College Name"
                                                            class="colorblack" formControlName="CgCode">
                                                            <mat-select-filter *ngIf="select222.focused"
                                                                [placeholder]="'College Name'"
                                                                [displayMember]="'CgName'" [array]="collegeList"
                                                                (filteredReturn)="filteredCollegeList =$event">
                                                            </mat-select-filter>
                                                            <mat-option *ngFor="let item of filteredCollegeList"
                                                                [value]="item.CgCode">
                                                                {{ item | displayValue:'CgCode':'CgName' }}
                                                            </mat-option>
                                                        </mat-select>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div class="col-sm-3">
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label>Centre </mat-label>
                                                        <input formControlName="Cent" matInput placeholder="Centre">
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div class="col-sm-3">
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label>Roll No </mat-label>
                                                        <input formControlName="RollNo" matInput placeholder="Roll No">
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div class="col-sm-3">
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label>Name Like</mat-label>
                                                        <input formControlName="RgName" matInput placeholder="Name Like">
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div class="col-sm-3">
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label> Gender</mat-label>
                                                        <mat-select #select23 placeholder="" class="colorblack"
                                                            formControlName="Sex">
                                                            <mat-select-filter *ngIf="select23.focused"
                                                                [placeholder]="'Filter'" [displayMember]="'CdDesc'"
                                                                [array]="genderList"
                                                                (filteredReturn)="filteredGenderList =$event">
                                                            </mat-select-filter>
                                                            <mat-option *ngFor="let item of filteredGenderList"
                                                                [value]="item.CdCode">
                                                                {{item.CdDesc}}
                                                            </mat-option>
                                                        </mat-select>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div class="col-sm-3">
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label> Branch</mat-label>
                                                        <mat-select #select28 placeholder="" class="colorblack"
                                                            formControlName="StrCode">
                                                            <mat-select-filter *ngIf="select28.focused"
                                                                [placeholder]="'Filter'" [displayMember]="'StrName'"
                                                                [array]="streamList"
                                                                (filteredReturn)="filteredStreamList =$event">
                                                            </mat-select-filter>
                                                            <mat-option *ngFor="let item of filteredStreamList"
                                                                [value]="item.StrCode">
                                                                {{item.StrName}}
                                                            </mat-option>
                                                        </mat-select>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div class="col-sm-3">
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label>Pass/Fail</mat-label>
                                                        <input formControlName="PassFail" matInput placeholder="Pass/Fail">
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div class="col-sm-3">
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label>Status</mat-label>
                                                        <mat-select formControlName="EfStatus" #select104
                                                            class="colorblack">
                                                            <mat-option value="O">Open</mat-option>
                                                            <mat-option value="C">Close</mat-option>
                                                        </mat-select>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div class="col-sm-3">
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label>Batch Like</mat-label>
                                                        <input formControlName="EfBatch" matInput placeholder="Batch Like">
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div class="col-sm-3">
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label>W/H</mat-label>
                                                        <mat-select formControlName="WH" #select104
                                                            class="colorblack">
                                                            <mat-option value="W">W</mat-option>
                                                            <mat-option value="H">H</mat-option>
                                                        </mat-select>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div class="col-sm-3">
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label>IncM</mat-label>
                                                        <input formControlName="Inc" matInput placeholder="IncM">
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div class="col-sm-3">
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label>Decl</mat-label>
                                                        <input formControlName="Decl" matInput placeholder="Decl">
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div class="col-sm-3">
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label>Marks% From</mat-label>
                                                        <input formControlName="EfPCFr" matInput placeholder="Marks% From">
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div class="col-sm-3">
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label>Marks% To</mat-label>
                                                        <input formControlName="EfPCTo" matInput placeholder="Marks% To">
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                           
                                            <div class="row col-sm-12">
                                                <div class="col-sm-12 prpl">
                                                    <button type="button" (click)="Back()"
                                                    class="btn sz btn-primary btn-icon-text floatright mt-1 fr">
                                                    <span style="display: contents; align-items: center;">
                                                        <img width="20vh" src="../../assets/img/exit.gif" style="margin-right: 5px;">
                                                        Exit
                                                    </span>
                                                    </button>
                                                    <button type="button" class="btn size1 btn-primary btn-icon-text floatright mr-3 mt-1"
													(click)="reset()">
													<span style="display: contents; align-items: center;">
														<img width="20vh" src="../../assets/img/refresh.gif">
														Reset
													</span>
												</button>
                                                    <button type="button" class="btn size1 btn-primary btn-icon-text floatright mr-3 mt-1">
                                                        Images
                                                    </button>
                                                    <!-- <button type="button" (click)="print()" class="btn btn-primary btn-icon-text floatright mr-3 mt-1">
                                                        <span style="display: contents; align-items: center;">
                                                            <img width="15vh" src="../../assets/img/printer.gif" style="margin-right: 7px;">
                                                            Print
                                                        </span>
                                                    </button> -->
                                            
                                                    <button type="button" (click)="getData()" class="btn size1 btn-primary btn-icon-text floatright mr-3 mt-1">
                                                        <span style="display: contents; align-items: center;">
                                                            <img width="15vh" src="../../assets/img/list.gif" style="margin-right: 7px;">
                                                            List
                                                        </span>
                                                    </button>
                                                   
                                                </div>
                                            </div>
                                        </div>
                                        <hr class="mt-3">
                                        <div class="col-sm-12 pl-0">
                                            <!--  -->
                                            <div *ngIf="Table">
                                                <div class="table-responsive table-container" id="table">
                                                    <table class="table table-bordered text-nowrap">
                                                        <thead>
                                                            <tr class="text-left">
                                                                <th class="f600">
                                                                    Id
                                                                </th>
                                                                <th class="f600">
                                                                    Sh
                                                                </th>
                                                                <th class="f600">
                                                                    Rg
                                                                </th>
                                                                <th class="f600">
                                                                    Em
                                                                </th>
                                                                <th class="f600">
                                                                    Br
                                                                </th>
                                                                <th class="f600">
                                                                    Ec
                                                                </th>
                                                                <th class="f600">
                                                                    Pr
                                                                </th>
                                                                <th class="f600">
                                                                    Sp
                                                                </th>
                                                                <th class="f600">
                                                                    Batch
                                                                </th>
                                                                <th class="f600">
                                                                    RgNo
                                                                </th>
                                                                <th class="f600">
                                                                    Colg
                                                                </th>
                                                                <th class="f600">
                                                                    Form
                                                                </th>
                                                                <th class="f600">
                                                                    Name
                                                                </th>
                                                                <th class="f600">
                                                                    Category
                                                                </th>
                                                                <th class="f600">
                                                                    BR
                                                                </th>
                                                                <th class="f600">
                                                                  Action
                                                                </th>
                                                                <!-- <th class="f600">
                                                                    Town
                                                                </th>
                                                                <th class="f600">
                                                                    Inc
                                                                </th>
                                                                <th class="f600">
                                                                    Cd
                                                                </th> -->
                                                            </tr>
                                                        </thead>
                                                        <tbody class="curs">
                                                                <!-- (click)="editdata(item)"  [class.selected-row]="item === selectedRow" (click)="selected(item)"-->
                                                            <tr *ngFor="let item of GridData;">
                                                                <td>{{item.EfId}}</td>
                                                                <td>{{item.EfShId}}</td>
                                                                <td>{{item.EfRgId}}</td>
                                                                <td>{{item.EfEmId}}</td>
                                                                <td>{{item.EfStrId}}</td>
                                                                <td>{{item.EfEcId}}</td>
                                                                <td>{{item.EfPress}}</td>
                                                                <td>{{item.EfSpFlag}}</td>
                                                                <td>{{item.EfBatch}}</td>
                                                                <td>{{item.RgNo}}</td>
                                                                <td>{{item.EfCgCode}}</td>
                                                                <td>{{item.EfFormNo}}</td>
                                                                <td>{{item.RgName}}</td>
                                                                <td>{{item.EfCate}}</td>
                                                                <td>{{item.StrCode}}</td>
                                                                <td>
                                                                    <a class=" ml-2 floating letterBtn" title="Subject" [class.selected-row]="item === selectedRow" (click)="selected(item)" >
                                                                        <!-- <i class="fas fa-trash"></i> -->
                                                                        <img width="25vh" src="../../assets/img/letter-s.gif" >
                                                                    </a>

                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </form>
</body>